import React from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useNotification } from '@ancert/aui-notification-context';
import AUIButton from '@ancert/aui-button';
import AUIDropdownField from '@ancert/aui-dropdown-field';
import AUIInputTextField from '@ancert/aui-input-text-field';
import AUIInputPasswordField from '@ancert/aui-input-password-field';
import { ROUTES } from '../../constants';
import { defaultValues, resolver } from './form';
import { ROL } from '../../lib/role.enum';
import { postLogin } from '../../services/user.service';
import postCertificate from '../../services/access.service';

const OPTIONS = [
  { label: 'Gestor/Administrador', value: 'ADMINISTRADOR' },
  { label: 'Autoridad', value: 'AUTORIDAD' },
];
const AccesoAutorizado = () => {
  const isDesktop = window.screen.width >= 1024;
  const history = useHistory();
  const { openNotification } = useNotification();
  const { control, formState, handleSubmit, watch } = useForm({
    defaultValues,
    resolver,
    mode: 'onSubmit',
  });

  const isAutoridad = watch('role') === 'AUTORIDAD';

  const errorModal = (message) => {
    openNotification({
      title: 'Error',
      content: <div>{message || 'Ha ocurrido en el inicio de sesión.'}</div>,
      type: 'error',
      centerButtons: true,
    });
  };

  const loginResponse = ({ status, result, error }) => {
    if (status === 200) {
      const { jwtToken, refreshToken, user, renewPassword } = result;
      sessionStorage.setItem('jwtToken', jwtToken);
      sessionStorage.setItem('refreshToken', refreshToken);
      sessionStorage.setItem('user', btoa(JSON.stringify(user)));
      sessionStorage.setItem('renewPassword', btoa(JSON.stringify(renewPassword)));
      if (user?.role === ROL.DENUNCIANTE) {
        history.push(ROUTES.LISTADO_DENUNCIA);
      } else {
        history.push(ROUTES.BACK_OFFICE);
      }
      return;
    }
    const { message } = error;
    errorModal(message || error);
  };

  const login = async (data) => {
    const { status, data: result, error } = await postLogin({ data });
    loginResponse({ status, result, error });
  };

  const adminLogin = async () => {
    const { status, data: result, error } = await postCertificate();
    loginResponse({ status, result, error });
  };

  const onSubmit = (data) => {
    const { role, user, password } = data;
    if (role === ROL.AUTORIDAD) {
      login({ user, password });
      return;
    }
    adminLogin();
  };

  const buttonLabel = () => {
    if (!isDesktop) {
      return 'Acceso disponible solo en PC';
    }
    if (isAutoridad) {
      return 'Acceder';
    }
    return 'Seleccionar certificado de acceso';
  };
  return (
    <div className="o-sii-main-container c-sii-acceso-autorizado">
      <h1>Acceso personal autorizado</h1>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <div className="o-grid">
          <div className="o-grid__row">
            <div className="o-grid__col-12">
              <AUIDropdownField
                name="role"
                label="Tipo de usuario"
                controlRef={control}
                errors={formState.errors}
                options={OPTIONS}
                appendTo={null}
              />
            </div>
          </div>
          {isAutoridad ? (
            <>
              <p>Introduzca sus datos para acceder:</p>
              <div className="o-grid__row u-mt-16">
                <div className="o-grid__col-12">
                  <AUIInputTextField
                    required
                    name="user"
                    label="Usuario"
                    controlRef={control}
                    errors={formState.errors}
                  />
                </div>
              </div>
              <div className="o-grid__row">
                <div className="o-grid__col-12">
                  <AUIInputPasswordField
                    required
                    name="password"
                    label="Contraseña"
                    toogleMask
                    controlRef={control}
                    errors={formState.errors}
                  />
                </div>
              </div>
            </>
          ) : (
            <p>
              Asegúrase de que tiene instalado en su equipo el certificado necesario para acceder a esta plataforma y
              pulse el siguiente botón para continuar.
            </p>
          )}
        </div>
        <div className="c-sii-acceso-autorizado__btn">
          <AUIButton
            size="lg"
            className="c-sii-acceso-autorizado__login"
            disabled={!isDesktop}
            label={buttonLabel()}
            type="submit"
          />
        </div>
      </form>
    </div>
  );
};

export default AccesoAutorizado;
